<template>
  <div>
    <button type="button" class="btn btn-primary btn-voltar" @click="$router.back()">
      <font-awesome-icon :icon="'arrow-left'" />
      Voltar
    </button>
    <Container title="Adicionar Escala">
      <SelectReferencia v-model="referencia" />
      <SelectUOR v-model="uor" :referencia="referencia" />
      <Calendar v-model="scaleDefault" :referencia="referencia" :disabled="hasEmployeesSelected" />
      <div class="colaborador-wrapper">
        <EmployeeReplicate v-model="employeesSelected" :disabled="scaleDefaultIsEmpty" :uor="uor_sigla"
          @changeStatusLoading="changeStatusLoading" />
        <EmployeeSearch v-model="employeesSelected" :disabled="scaleDefaultIsEmpty" />
      </div>
      <EmployeeList v-model="employeesSelected" :loading="statusLoading" />

      <div class="form-group">
        <label :class="[
          'control-label',
          'custom-font',
          { 'is-danger': errors.has('observacao') }
        ]">Observação</label>
        <div class="inputgroupcontainer">
          <div class="input-group">
            <span class="input-group-addon">
              <font-awesome-icon :icon="'exclamation-triangle'" />
              <!-- <font-awesome-icon :icon="'tags'"
                  :class="[{ 'is-danger': errors.has('observacao') }]"></font-awesome-icon> -->
            </span>
            <textarea ref="observacao" rows="4" v-model="observacao" placeholder="Observação" class="form-control"
              maxlength="500">
                  </textarea>
            <div :class="[
              'input-group-addon custom-input-group-addon-count',
              { 'is-danger': errors.has('observacao') }
            ]" v-text="500 - observacao.length"></div>
          </div>
        </div>
      </div>

      <footer>
        <button @click.prevent="save()" class="btn btn-default" :disabled="statusLoading">
          <font-awesome-icon v-if="statusLoading" :icon="'spinner'" spin />
          <font-awesome-icon v-else :icon="'save'" />
          Salvar
        </button>
      </footer>
    </Container>
  </div>
</template>

<script>
import { request } from '@/request'
import Container from '@/components/Container'
import SelectUOR from '@/components/SelectUOR'
import SelectReferencia from '@/components/Escala/SelectReferencia'
import Calendar from '@/components/Calendar'
import EmployeeReplicate from '@/components/Employee/Replicate'
import EmployeeSearch from '@/components/Employee/Search'
import EmployeeList from '@/components/Employee/List'

export default {
  components: {
    Container,
    SelectUOR,
    SelectReferencia,
    Calendar,
    EmployeeReplicate,
    EmployeeSearch,
    EmployeeList
  },
  beforecreate() {
    if (!this.$store.state.islogged) {
      this.$router.push('/login')
    }
  },
  data() {
    return {
      uor: '',
      referencia: '',
      scaleDefault: {},
      employeesSelected: [],
      observacao: '',
      statusLoading: false
    }
  },
  computed: {
    scaleDefaultIsEmpty() {
      return Object.entries(this.scaleDefault).length === 0
    },
    hasEmployeesSelected() {
      return this.employeesSelected.length > 0
    },
    uor_sigla() {
      return this.uor.split('|')[0]
    },
    uor_nome() {
      return this.uor.split('|')[1]
    }
  },
  watch: {
    employeesSelected(value) {
      const newItens = value.filter(
        employee => !employee.hasOwnProperty('scale')
      )
      newItens.forEach(employee => {
        employee.scale = this.scaleDefault.dates.map(item => ({ ...item }))
      })
    },
  },
  methods: {
    async save() {
      const {
        validateForm,
        getPayload,
        getPayloadChuncks,
        success,
        fail
      } = this
      if (validateForm()) {
        let success = true
        let index = 0

        request.post('escala/add', { ...getPayload() })
        .then(this.success)
        .catch((error) => {
          this.$toastr.e(error.response.data)
        })

        //const payloads = getPayloadChuncks(9)

        // do {
        //   const { status } = await request.post('escala/add', { ...payloads[index++] })
        //   success = status === 200
        // } while (index < payloads.length && success)

        // if (success) {
        //   this.$toastr.s('Escala adicionada com sucesso!')
        // } else {
        //   this.$toastr.e('Houve uma falha ao tentar adicionar a escala, verifique na listagem se todos foram adicionados!')
        // }

        // this.$router.push('list')

        // const { status } = await request.post('escala/add', { ...payload })

        // if (status === 200) {
        //   this.success()
        // } else {
        //   this.fails()
        // }

        // request.post('escala/add', payload, success, fail)
      }
    },
    validateForm() {
      const { uor, scaleDefault, employeesSelected } = this

      if (uor === undefined) {
        this.$toastr.e('Selecione uma unidade!')
        return false
      }

      if (scaleDefault.dates.length === 0) {
        this.$toastr.e('Escolha os dias da escala no calendário!')
        return false
      }

      if (employeesSelected.length === 0) {
        this.$toastr.e('Escolha os colaboradores!')
        return false
      }

      if (employeesSelected.find(item => item.scaleStatus === 'invalid')) {
        this.$toastr.e(
          'Favor resolver os conflitos de escala dos funcionários!'
        )
        return false
      }

      return true
    },
    getPayload() {
      const {
        uor_sigla,
        uor_nome,
        observacao,
        referencia
      } = this

      const colaboradores = this.employeesSelected.map(({ id: colaborador_id, scale }) => {
        // filtrar a escala somente pelos dias ativos e com times maior que zero
        const escalaFiltrada = scale.filter(({ active, times }) => active && times.length > 0)

        // preparar a escala com a estrutra 1 horario -> lista de dias
        const horariosDatas = {}
        escalaFiltrada.forEach(({ date, times }) => {
          const data = date.toLocaleDateString('pt-BR', { month: '2-digit', day: '2-digit' })
          times.forEach(({ entrada, saida }) => {
            const keyTime = JSON.stringify({ entrada, saida })
            if (horariosDatas.hasOwnProperty(keyTime))
              horariosDatas[keyTime].datas.push(data)
            else
              horariosDatas[keyTime] = { entrada, saida, datas: [data] }
          })
        })

        // finalizar convertendo o objeto de horarios em array
        const horarios_datas = Object.keys(horariosDatas).length > 0 ? JSON.stringify(Object.values(horariosDatas)) : false

        return { colaborador_id, horarios_datas }
      })

      return {
        uor_sigla,
        uor_nome,
        referencia,
        observacao,
        colaboradores
      }
    },
    getPayloadChuncks(size) {
      const { escala, referencia, uor } = this.getPayload()
      const payloads = []

      for (var i = 0; i < escala.length; i += size) {
        payloads.push({
          escala: escala.slice(i, i + size),
          referencia,
          uor_sigla: uor.sigla,
          uor_nome: uor.nome
        })
      }

      return payloads
    },
    success() {
      this.$toastr.s('Escala adicionada com sucesso!')
      this.$router.push('list')
    },
    fails() {
      this.$toastr.e(
        'Houve uma falha ao tentar adicionar a escala, Tente novamente daqui alguns minutos!'
      )
    },
    changeStatusLoading(value) {
      this.statusLoading = value
    }
  }
}
</script>

<style>
.text-muted {
  color: #999;
}

.colaborador-wrapper {
  display: flex;
  justify-content: space-between;
}

.colaborador-wrapper section:last-child {
  margin-left: 16px;
}

.form-group {
  margin-top: 5px;
}

.form-group label {
  font-size: 14px;
  font-weight: 600;
  color: #1a202c;
  font-family: BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
}

footer {
  display: block;
  flex-direction: row;
  justify-content: flex-end;
  margin: 10px 0;
}

.btn-voltar {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/escalas/Save.vue